import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import TableHeader from "../../../../components/Table/TableHeader";
import TablePagination from "../../../../components/Table/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../../components/InputSearch";
import { FaRegArrowAltCircleUp, FaRegArrowAltCircleDown } from "react-icons/fa";

const tabelaColunas = [
  "GTIN/EAN",
  "SKU",
  "Descrição",
  "Categoria",
  "Marca",
  "Seller CNPJ",
  "Razão Social",
  "Status Cadastro",
  "Data de proc.",
];

const PerfilSellerListProdutoSeller = ({
  response,
  buscar,
  busca,
  mudarPagina,
}) => {
  const history = useHistory();

  const changePage = (page) => {
    mudarPagina(page);
  };

  const [novaLista, setNovaLista] = useState([]);
  const gotoDet = (idProdutoSeller) => {
    history.push(`/produto/editar/${idProdutoSeller}`);
  };

  useEffect(() => {
    setNovaLista(response.lista);
  }, [response]);

  return (
    <div className="produtos-lista">
      <div className="row">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.gtinEan - b.gtinEan
                      );
                      const isReversed =
                        novaLista[0].gtinEan === sorted[0].gtinEan;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    GTIN/EAN
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.sku - b.sku);
                      const isReversed = novaLista[0].sku === sorted[0].sku;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    SKU
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.nomeProduto - b.nomeProduto
                      );
                      const isReversed =
                        novaLista[0].nomeProduto === sorted[0].nomeProduto;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Descrição
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.categoria - b.categoria
                      );
                      const isReversed =
                        novaLista[0].categoria === sorted[0].categoria;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Categoria
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.marca - b.marca);
                      const isReversed = novaLista[0].marca === sorted[0].marca;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Marca
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) =>
                          a.dadosEmpresaSeller?.dadosCadastrais?.cnpj -
                          b.dadosEmpresaSeller?.dadosCadastrais?.cnpj
                      );
                      const isReversed =
                        novaLista[0].dadosEmpresaSeller?.dadosCadastrais
                          ?.cnpj ===
                        sorted[0].dadosEmpresaSeller?.dadosCadastrais?.cnpj;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Seller CNPJ
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) =>
                          a.dadosEmpresaSeller?.dadosCadastrais?.razaoSocial -
                          b.dadosEmpresaSeller?.dadosCadastrais?.razaoSocial
                      );
                      const isReversed =
                        novaLista[0].dadosEmpresaSeller?.dadosCadastrais
                          ?.razaoSocial ===
                        sorted[0].dadosEmpresaSeller?.dadosCadastrais
                          ?.razaoSocial;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Razão Social
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort((a, b) => a.status - b.status);
                      const isReversed =
                        novaLista[0].status === sorted[0].status;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Status Cadastro
                  </th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      var lista = [...novaLista];
                      const sorted = lista.sort(
                        (a, b) => a.dataAtualizacao - b.dataAtualizacao
                      );
                      const isReversed =
                        novaLista[0].dataAtualizacao ===
                        sorted[0].dataAtualizacao;
                      setNovaLista(isReversed ? sorted.reverse() : sorted);
                    }}
                  >
                    Data de proc.
                  </th>
                  <th style={{ cursor: "pointer" }}></th>
                </tr>
              </thead>
              <tbody>
                {(!novaLista || novaLista.length === 0) && (
                  <tr>
                    <td colSpan={tabelaColunas.length}> Sem Registros </td>
                  </tr>
                )}
                {novaLista &&
                  novaLista.map((data) => (
                    <tr key={data.id}>
                      <td>{data.gtin}</td>
                      <td>{data.sku}</td> {/* Assuming `gpc` maps to SKU */}
                      <td>{data.nomeProduto}</td>
                      <td>{data.categoria}</td>
                      <td>{data.marca}</td>
                      <td>{data.dadosEmpresaSeller?.dadosCadastrais?.cnpj}</td>
                      <td>
                        {data.dadosEmpresaSeller?.dadosCadastrais?.razaoSocial}
                      </td>
                      <td>{data.status ? "Completo" : "Incompleto"}</td>
                      <td>
                        {data.dataAtualizacao
                          ? new Date(data.dataAtualizacao).toLocaleDateString(
                              "pt-BR"
                            )
                          : ""}
                      </td>
                      <td className="text-right">
                        <i
                          className="btn-edit-icon btn btn-icon fa fa-edit"
                          onClick={() => gotoDet(data.id)}
                        ></i>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <TablePagination data={response} changePage={changePage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerfilSellerListProdutoSeller;
